import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import Alerta from "./Alerta";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import {
  Contact,
  Title,
  Description,
  DivForm,
  Formulario,
  Ul,
  FormRow,
  FormGroup,
  InputText,
  Message,
  SpanError,
  LiSubmit,
  Submit
} from '../styles/contact.styles';
import emailConfig from '../utils/email';

const schema = yup.object().shape({
  name: yup.string()
    .min(3, "El nombre debe tener al menos 3 caracteres")
    .required('Nombre requerido'),
  email: yup.string()
    .email('Email inválido')
    .required('Email requerido'),
  subject: yup.string()
    .min(10, "El asunto debe tener al menos 10 caracteres")
    .required('Asunto requerido'),
  message: yup.string()
    .min(20, "El mensaje debe tener al menos 20 caracteres")
    .required('Mensaje requerido'),
});

const Contacto = () => {
  const form = useRef();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onTouched',
  });

  const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
  const [alerta, cambiarAlerta] = useState({});

  const sendEmail = async (formData) => {
    try {
      await emailjs.send(
        emailConfig.serviceName, 
        emailConfig.templateName, 
        formData,
        emailConfig.emailApiKey
      ).then(
        function (response) {
          cambiarEstadoAlerta(true);
          cambiarAlerta({
            tipo: 'exito',
            mensaje: 'Tu mensaje ha sido enviado exitosamente!',
          });

          reset();
        },
        function (err) {
          console.error('Email send error:', err);
          cambiarEstadoAlerta(true);
          cambiarAlerta({
            tipo: 'error',
            mensaje: 'Algo salió mal, no se pudo enviar tu mensaje.',
          });
        },
      );
    } catch (error) {
      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: 'error',
        mensaje: 'Server error. Please contact admin: alan.developnett@gmail.com',
      });
    }
  };

  return (
    <Contact id="contacto">
      <Title>Contáctame</Title>
      <Description>
        ¿Tienes en mente una página web o un sistema para mejorar la gestión de tu negocio? Estoy aquí para ayudarte. Escríbeme y platiquemos sobre tu proyecto.
      </Description>

      <DivForm>
        <Formulario ref={form} onSubmit={handleSubmit(sendEmail)}>
          <Ul>
            <FormRow>
              <FormGroup>
                <label htmlFor="name">Nombre</label>
                <InputText
                  type='text'
                  id="name"
                  placeholder="Tu nombre completo"
                  {...register('name')}
                />
                {errors.name && (
                  <SpanError>
                    <p>{errors.name.message}</p>
                  </SpanError>
                )}
              </FormGroup>

              <FormGroup>
                <label htmlFor="email">Correo electrónico</label>
                <InputText
                  type='email'
                  id="email"
                  placeholder="tu@email.com"
                  {...register('email')}
                />
                {errors.email && (
                  <SpanError>
                    <p>{errors.email.message}</p>
                  </SpanError>
                )}
              </FormGroup>
            </FormRow>

            <FormGroup>
              <label htmlFor="subject">Asunto</label>
              <InputText
                type='text'
                id="subject"
                placeholder="¿En qué puedo ayudarte?"
                {...register('subject')}
              />
              {errors.subject && (
                <SpanError>
                  <p>{errors.subject.message}</p>
                </SpanError>
              )}
            </FormGroup>

            <FormGroup>
              <label htmlFor="message">Mensaje</label>
              <Message
                id="message"
                placeholder="Cuéntame sobre tu proyecto o idea..."
                {...register('message')}
              />
              {errors.message && (
                <SpanError>
                  <p>{errors.message.message}</p>
                </SpanError>
              )}
            </FormGroup>

            <LiSubmit>
              <Submit type='submit'>
                Enviar mensaje
              </Submit>
            </LiSubmit>
          </Ul>
        </Formulario>

        <Alerta
          tipo={alerta.tipo}
          mensaje={alerta.mensaje}
          estadoAlerta={estadoAlerta}
          cambiarEstadoAlerta={cambiarEstadoAlerta}
        />
      </DivForm>
    </Contact>
  );
};

export default Contacto;